// @flow
import { reducer as formReducer } from 'redux-form';
import results from './results.reducer';
import popular from './popular.reducer';
import listing from './listing.reducer';
import shortlist from './shortlist.reducer';
import ui from './ui.reducer';
import viewport from './viewport.reducer';
import customForm from './custom-form';

// $FlowFixMe
const form = formReducer.plugin(customForm);

export { results, ui, listing, form, viewport, shortlist, popular };



// WEBPACK FOOTER //
// ./src/reducers/index.js